<div class="backdrop">
  <div class="modal">
    <div class="modal-header">
      <img src="../../assets/img/chiudi.svg" alt="chiudi" class="close-icon" (click)="close()" />
    </div>
    <div class="modal-content">
      <div class="video-container" *ngIf="!!videoUrl">
        <video width="1000" height="562" controls [autoplay]="true" [muted]="true">
          <source [src]="videoUrl" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  </div>
</div>
